export default __webpack_public_path__ + "static/media/Banner-image-2.8c9bbf74.jpg";